import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useThunkDispatch } from "store";
import { contractSelectors } from "store/contracts";
import { dashboardSelectors, dashboardThunks } from "store/dashboard";

const useFetchDashboardData = () => {
  const thunkDispatch = useThunkDispatch();
  const selectedContractId = useSelector(contractSelectors.getSelectedContractId);

  useEffect(() => {
    const controller = new AbortController();
    if (selectedContractId) {
      thunkDispatch(dashboardThunks.getStatusInfo(selectedContractId, controller.signal));
      thunkDispatch(dashboardThunks.getUserCountInfo(selectedContractId, controller.signal));
      thunkDispatch(dashboardThunks.getDocuments30DaysInfo(selectedContractId, controller.signal));
      thunkDispatch(dashboardThunks.getClosedDocuments6MonthsInfo(selectedContractId, controller.signal));
    }

    return () => controller.abort();
  }, [thunkDispatch, selectedContractId]);

  return useSelector(dashboardSelectors.getSlice);
};

export default useFetchDashboardData;
